/**
 * Created by alberto on 2015-02-24.
 */
define('payment/handlers/kyc-validator',['require', 'jquery', 'all/slider', 'boxes/helpers/tooltip', 'boxes/events/feeEvent', 'all/comeon',
    'all/paymentServices-toggles'], function (require, $, slider, tooltip, feeEvent, comeon, paymentServicesToggles) {

    'use strict';

    var METHOD_CREDIT_CARD = 'CREDIT-CARD';
    var kycValidator = {};
    var withdrawBox = {};
    var creditCardDetails = {};

    function getKYCPendingStatusURL() {
        return paymentServicesToggles.useNewPaymentFormDataService() ? '/PaymentFormDataService/getPendingKYCStatus' : '/pp?flow=GetPendingKYCStatus';
    }

    function getValidateKYCStatusURL() {
        return paymentServicesToggles.useNewPaymentFormDataService() ? '/PaymentFormDataService/getValidateKYCStatus' : '/pp?flow=GetValidateKYCStatus';
    }

    function validateKYC(methodId, amount, currency) {
        var data = {
            method: methodId,
            currency: currency,
            amount: amount
        };
        var ajaxPromise = comeon.promise.create();
        $.get(getValidateKYCStatusURL(), data, function (dataResult) {
            ajaxPromise.resolve(dataResult);
        });
        return ajaxPromise.promise();
    }

    function validateKYCForCreditCards(methodId, amount, currency) {
        fetchCreditCardDetails(creditCardDetails);
        var cid = creditCardDetails.cid;
        var data = {
            cid: cid,
            method: methodId,
            amount: amount,
            currency: currency,
            'cc-number': creditCardDetails.CardNumber
        };
        var ajaxPromise = comeon.promise.create();
        $.get(getValidateKYCStatusURL(), data, function (dataResult) {
            ajaxPromise.resolve(dataResult);
        });
        return ajaxPromise.promise();
    }

    function fetchCreditCardDetails(cardDetails) {
        //Get input entries
        withdrawBox.$box.find('.payment-method-form').find('dd').each(function () {
            var key = $(this).attr('class');
            cardDetails[key] = $(this).text();
        });
    }

    function requestKYC(methodId, amount, currency, formTemplateCode) {
        if (formTemplateCode === METHOD_CREDIT_CARD) {
            return validateKYCForCreditCards(methodId, amount, currency);
        } else {
            return validateKYC(methodId, amount, currency);
        }
    }

    function requestHasPendingDocuments(methodId, formTemplate) {
        var cid = withdrawBox.$box.find(formTemplate.getSelectorClass()).find('dd').filter(function(){
            return $(this).attr('class') === 'cid';
        }).text();
        var data = {method: methodId, cid: cid, isMobileDevice: false};
        var ajaxPromise = comeon.promise.create();
        $.get(getKYCPendingStatusURL(), data, function(dataResult){
            ajaxPromise.resolve(dataResult);
        });
        return ajaxPromise.promise();
    }

    kycValidator.init = function(withdrawBoxReference){
        withdrawBox = withdrawBoxReference;
    };

    kycValidator.validate = function(methodId, amount, currency, formTemplateCode){
        return requestKYC(methodId, amount, currency, formTemplateCode);
    };

    kycValidator.hasPendingDocuments = function(methodId, formTemplate){
        return requestHasPendingDocuments(methodId, formTemplate);
    };

    return kycValidator;
});

